// Contact Section Data
import { SectionHeader, ContactOption } from '../data/schemas';
import { contactLinks } from './links';

export const contactData = {
  header: new SectionHeader("Get In Touch", "Contact Me", "contact"),
  
  options: [
    new ContactOption(
      "BsFillEnvelopeFill",
      "Email",
      contactLinks.emailAddress,
      contactLinks.emailHref,
      "react-icons/bs"
    ),
    new ContactOption(
      "FaFacebookMessenger",
      "Facebook Messenger",
      "Rasheed Abu Khader",
      contactLinks.messengerHref,
      "react-icons/fa"
    ),
    new ContactOption(
      "ImWhatsapp",
      "WhatsApp",
      contactLinks.whatsappNumber,
      contactLinks.whatsappHref,
      "react-icons/im"
    )
  ],
  
  form: {
    emailjs: {
      serviceId: 'service_3da1dwm',
      templateId: 'template_zvz7rla',
      publicKey: 'yn31vXL-orI1vdJnO'
    },
    fields: [
      { name: 'name', type: 'text', placeholder: 'Your Full Name', required: true },
      { name: 'email', type: 'email', placeholder: 'Your Email', required: true },
      { name: 'message', type: 'textarea', placeholder: 'Your Message', required: true, rows: 7 }
    ],
    submitText: 'Send Message'
  }
};
